exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".text-ed66d{max-width:50.5rem}.text-ed66d .customBreakLine-f3dfb{display:none}@media(min-width: 530px){.text-ed66d{white-space:nowrap}.text-ed66d .customBreakLine-f3dfb{display:block}}", ""]);

// Exports
exports.locals = {
	"text": "text-ed66d",
	"customBreakLine": "customBreakLine-f3dfb"
};